var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfeedbackInvestigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14785_3405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0496 1.18347V7.50013H31.3666L25.0496 1.18347Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2539 9.83411H16.3457V12.3321H12.2539V9.83411Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91989 34.6659V5.16736H1.75268C1.10833 5.16736 0.585938 5.68975 0.585938 6.3341V39.3333C0.585938 39.9776 1.10833 40.5 1.75268 40.5H26.2155C26.8599 40.5 27.3822 39.9776 27.3822 39.3333V38.1661H6.42011C4.49009 38.1661 2.91989 36.5959 2.91989 34.6659Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0498 28.1907C34.6273 28.1907 36.7167 26.1013 36.7167 23.5238C36.7167 20.9463 34.6273 18.8568 32.0498 18.8568C29.4723 18.8568 27.3828 20.9463 27.3828 23.5238C27.3828 26.1013 29.4723 28.1907 32.0498 28.1907Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0493 23.5238C25.0493 19.6637 28.1897 16.5233 32.0497 16.5233V9.83362H23.8828C23.2384 9.83362 22.716 9.31123 22.716 8.66687V0.5H6.42016C5.77581 0.5 5.25342 1.02239 5.25342 1.66674V34.6659C5.25342 35.3103 5.77581 35.8326 6.42016 35.8326H30.883C31.5273 35.8326 32.0497 35.3103 32.0497 34.6659V30.5242C28.1897 30.5242 25.0493 27.3838 25.0493 23.5238ZM9.92038 8.66734C9.92038 8.02299 10.4428 7.5006 11.0871 7.5006H17.5124C18.1568 7.5006 18.6792 8.02299 18.6792 8.66734V13.4988C18.6792 14.1432 18.1568 14.6656 17.5124 14.6656H11.0871C10.4428 14.6656 9.92038 14.1432 9.92038 13.4988V8.66734ZM11.0871 16.9995H21.2557C21.9 16.9995 22.4224 17.5219 22.4224 18.1662C22.4224 18.8106 21.9 19.333 21.2557 19.333H11.0871C10.4428 19.333 9.92038 18.8106 9.92038 18.1662C9.92038 17.5219 10.4428 16.9995 11.0871 16.9995ZM11.0871 21.6669H20.3933C21.0376 21.6669 21.56 22.1893 21.56 22.8337C21.56 23.4781 21.0376 24.0004 20.3933 24.0004H11.0871C10.4428 24.0004 9.92038 23.4781 9.92038 22.8337C9.92038 22.1893 10.4428 21.6669 11.0871 21.6669ZM21.7312 28.6678H11.0871C10.4428 28.6678 9.92038 28.1455 9.92038 27.5011C9.92038 26.8568 10.4428 26.3344 11.0871 26.3344H21.7312C22.3756 26.3344 22.898 26.8568 22.898 27.5011C22.898 28.1455 22.3756 28.6678 21.7312 28.6678Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0688 29.8928L37.7537 27.5778C37.2994 28.215 36.7411 28.7734 36.1038 29.2278L38.4188 31.5428C38.6466 31.7706 38.9452 31.8846 39.2438 31.8846C39.5424 31.8846 39.841 31.7706 40.0688 31.5428C40.5245 31.0872 40.5245 30.3484 40.0688 29.8928Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14785_3405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfeedbackInvestigate);
export default __webpack_public_path__ + "static/media/ifeedback_investigate.de05335efc090d8921c44de68c6b3cb0.svg";
export { ForwardRef as ReactComponent };